import React from "react";
import "./App.css";
// material
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// routes
import Router from "./routes";
// i18
import "src/locales/i18n";
// theme
import ThemeProvider from "./theme";
// components
import { MotionLazyContainer } from "./components/animate";
import { ProgressBarStyle } from "./components/ProgressBar";
import ThemeSettings from "./components/settings";
import Alert from "./components/Alert";
import FullScreenConfetti from "./components/FullScreenConfetti";
import MaintenancePopUp from "./components/MaintenancePopUp";

// ------------------------------------------------------------------------

function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <ProgressBarStyle />
            <Router />
            <Alert />
            <MaintenancePopUp />
            <FullScreenConfetti />
          </LocalizationProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}

export default App;
